import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  const _component_RouterView = _resolveComponent("RouterView");
  return _openBlock(), _createElementBlock("main", null, [(_openBlock(), _createBlock(_component_RouterView, {
    key: _ctx.$route.fullPath
  }))]);
}